import React from 'react'
import ApproverExpenseReports from 'src/app/ApproverExpenseReports/ApproverExpenseReports'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { expensesOutOfPocketReportsYoursRouteProps } from 'src/navigation/routeProps'

const SubmitExpensesAppRoute: AppRoute = {
  id: AppLocation.MyWalletReimbursements,
  routeProps: expensesOutOfPocketReportsYoursRouteProps,
  component: <ApproverExpenseReports yourExpenses />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default SubmitExpensesAppRoute
